import _regeneratorRuntime from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/haakseth/Workspace/Septima/plandk2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Class, fetch2 } from '../utils';
import Searcher from './Searcher';
export default Class(Searcher, {
  initialize: function initialize(options) {
    this.Searcher(options);
    this.source = "Plansystem";
    if (options.source) this.source = options.source;
    this.registerType(this.source, "Kommuneplanramme");
    this.registerType(this.source, "Regionplan");
    this.registerType(this.source, "Byggefelt");
    this.registerType(this.source, "Delområde");
    this.types = {
      "kpl": {
        id: "kommuneplanramme",
        singular: "Kommuneplanramme",
        plural: "Kommuneplanrammer"
      },
      "rp": {
        id: "regionplan",
        singular: "Regionplan",
        plural: "Regionplaner"
      },
      "bf": {
        id: "byggefelt",
        singular: "Byggefelt",
        plural: "Byggefelter"
      },
      "do": {
        id: "delområde",
        singular: "Delområde",
        plural: "Delområde"
      }
    };
    this.registerType(this.source, this.types.kpl);
    this.registerType(this.source, this.types.rp);
    this.registerType(this.source, this.types.bf);
    this.registerType(this.source, this.types.do);
  },
  fetchData: function () {
    var _fetchData = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(query, caller) {
      var queryResult, plansystemResult, feature, title, description, geometry, result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryResult = this.createQueryResult();

              if (!(query.queryString !== "" && parseInt(query.queryString))) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return this.fetchKommuneplanRamme(query.queryString);

            case 4:
              plansystemResult = _context.sent;

              if (plansystemResult.features && plansystemResult.features.length === 1) {
                feature = plansystemResult.features[0];
                title = feature.properties.plannavn;
                description = feature.properties.anvendelsegenerel;
                geometry = feature.geometry;
                result = queryResult.addResult(this.source, this.types.kpl, title, description, geometry, feature);
                result.id = feature.properties.planid;
              }

            case 6:
              caller.fetchSuccess(queryResult);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function fetchData(_x, _x2) {
      return _fetchData.apply(this, arguments);
    }

    return fetchData;
  }(),
  get: function () {
    var _get = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2(id, type) {
      var plansystemResult, queryResult, feature, title, description, geometry, result, _plansystemResult, _queryResult, _feature, _title, _description, _geometry, _result, _plansystemResult2, _queryResult2, _feature2, _title2, _description2, _geometry2, _result2, _plansystemResult3, _queryResult3, _feature3, _title3, _description3, _geometry3, _result3;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(type == this.types.kpl.id)) {
                _context2.next = 15;
                break;
              }

              _context2.next = 3;
              return this.fetchKommuneplanRamme(id);

            case 3:
              plansystemResult = _context2.sent;

              if (!(plansystemResult.features && plansystemResult.features.length === 1)) {
                _context2.next = 13;
                break;
              }

              queryResult = this.createQueryResult();
              feature = plansystemResult.features[0];
              title = feature.properties.plannavn;
              description = feature.properties.anvendelsegenerel;
              geometry = feature.geometry;
              result = queryResult.addResult(this.source, type, title, description, geometry, feature);
              result.id = id;
              return _context2.abrupt("return", result);

            case 13:
              _context2.next = 61;
              break;

            case 15:
              if (!(type == this.types.bf.id)) {
                _context2.next = 30;
                break;
              }

              _context2.next = 18;
              return this.fetchByggeFelt(id);

            case 18:
              _plansystemResult = _context2.sent;

              if (!(_plansystemResult.features && _plansystemResult.features.length === 1)) {
                _context2.next = 28;
                break;
              }

              _queryResult = this.createQueryResult();
              _feature = _plansystemResult.features[0];
              _title = "Delnr: ".concat(_feature.properties.delnr);
              _description = "Lokalplan: ".concat(_feature.properties.lp_plannavn);
              _geometry = _feature.geometry;
              _result = _queryResult.addResult(this.source, type, _title, _description, _geometry, _feature);
              _result.id = id;
              return _context2.abrupt("return", _result);

            case 28:
              _context2.next = 61;
              break;

            case 30:
              if (!(type == this.types.do.id)) {
                _context2.next = 45;
                break;
              }

              _context2.next = 33;
              return this.fetchDelomraade(id);

            case 33:
              _plansystemResult2 = _context2.sent;

              if (!(_plansystemResult2.features && _plansystemResult2.features.length === 1)) {
                _context2.next = 43;
                break;
              }

              _queryResult2 = this.createQueryResult();
              _feature2 = _plansystemResult2.features[0];
              _title2 = "Delnr: ".concat(_feature2.properties.delnr);
              _description2 = "Lokalplan: ".concat(_feature2.properties.lp_plannavn);
              _geometry2 = _feature2.geometry;
              _result2 = _queryResult2.addResult(this.source, type, _title2, _description2, _geometry2, _feature2);
              _result2.id = id;
              return _context2.abrupt("return", _result2);

            case 43:
              _context2.next = 61;
              break;

            case 45:
              if (!(type == this.types.rp.id)) {
                _context2.next = 60;
                break;
              }

              _context2.next = 48;
              return this.fetchRegionPlan(id);

            case 48:
              _plansystemResult3 = _context2.sent;

              if (!(_plansystemResult3.features && _plansystemResult3.features.length === 1)) {
                _context2.next = 58;
                break;
              }

              _queryResult3 = this.createQueryResult();
              _feature3 = _plansystemResult3.features[0];
              _title3 = _feature3.properties.dokumentna.replace('Ã¸', 'ø').replace('tillg', 'tillæg').replace('Ã¦', 'æ').replace('Storstrom', 'Storstrøm').replace('Ribe_amt_samlet', ' Ribe Amt samlet').replace('Snderjyllands', 'Sønderjyllands').replace('Ringkbing', 'Ringkøbing').replace('Vestsjlland', 'Vestsjælland');
              _description3 = _feature3.properties.amtnavn.replace('Ã¸', 'ø').replace('Ã¦', 'æ').replace('Ã', 'Å');
              _geometry3 = _feature3.geometry;
              _result3 = _queryResult3.addResult(this.source, type, _title3, _description3, _geometry3, _feature3);
              _result3.id = id;
              return _context2.abrupt("return", _result3);

            case 58:
              _context2.next = 61;
              break;

            case 60:
              throw new Error('Whoops! get(id) is not implemented for ' + type);

            case 61:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function get(_x3, _x4) {
      return _get.apply(this, arguments);
    }

    return get;
  }(),
  fetchKommuneplanRamme: function () {
    var _fetchKommuneplanRamme = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3(id) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return fetch2("https://geoserver.plandata.dk/geoserver/wfs?request=getFeature&typename=theme_pdk_kommuneplanramme_alle_vedtaget_v&cql_filter=planid=".concat(id, "&outputFormat=json"));

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function fetchKommuneplanRamme(_x5) {
      return _fetchKommuneplanRamme.apply(this, arguments);
    }

    return fetchKommuneplanRamme;
  }(),
  fetchByggeFelt: function () {
    var _fetchByggeFelt = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4(id) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetch2("https://geoserver.plandata.dk/geoserver/wfs?request=getFeature&typename=theme_pdk_byggefelt_vedtaget_v&cql_filter=planid=".concat(id, "&outputFormat=json"));

            case 2:
              return _context4.abrupt("return", _context4.sent);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function fetchByggeFelt(_x6) {
      return _fetchByggeFelt.apply(this, arguments);
    }

    return fetchByggeFelt;
  }(),
  fetchRegionPlan: function () {
    var _fetchRegionPlan = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5(id) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return fetch2("https://geoserver.plandata.dk/geoserver/wfs?servicename=wfs&request=getFeature&typename=region:regionplaner&featureID=".concat(id, "&outputformat=json"));

            case 2:
              return _context5.abrupt("return", _context5.sent);

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function fetchRegionPlan(_x7) {
      return _fetchRegionPlan.apply(this, arguments);
    }

    return fetchRegionPlan;
  }(),
  fetchDelomraade: function () {
    var _fetchDelomraade = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6(id) {
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetch2("https://geoserver.plandata.dk/geoserver/wfs?request=getFeature&typename=theme_pdk_lokalplandelomraade_vedtaget_v&cql_filter=planid=".concat(id, "&outputFormat=json"));

            case 2:
              return _context6.abrupt("return", _context6.sent);

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function fetchDelomraade(_x8) {
      return _fetchDelomraade.apply(this, arguments);
    }

    return fetchDelomraade;
  }(),
  CLASS_NAME: 'Septima.Search.PlanSystemSearcher'
});